import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { toast } from "@/common/utils/toast";
import { config } from "@/common/settings/config";

import { userList, userAdd, userUpdate, userDel } from "@/common/api/rest/user";

import type { UserType, UserRegisterType } from "@/common/types/user";

import { PanelTheme } from "@/common/themes";
import { FormUser } from "@/components";
import {
  breadcrumbSimple,
  baseConfirm,
  baseModal,
  baseTable,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, tm } = useI18n();

const tableData = ref<UserType[]>([]);
const selected = ref<UserType | null>(null);
const payload = ref<UserRegisterType | null>(null);

const limit = ref<number>(10);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalDel = ref(false);
const payloadValid = ref(false);
const isEdit = ref(false);

const userTypes = computed(() => tm("user.types") as Record<string, string>);

const menuList = computed(() =>
  config.menu.register.map((item) => ({
    ...item,
    label: t(item.label),
  }))
);

const breadcrumbList = computed(() => [
  {
    key: "register",
    label: t("common.labels.registrations"),
    url: "/register",
  },
  {
    key: "users",
    label: t("common.labels.users"),
    url: "/register/user",
  },
]);

const tableHeader = computed(() => [
  { key: "id", label: "" },
  { key: "name", label: t("common.labels.name") },
  { key: "type", label: t("common.labels.type") },
  { key: "status", label: t("common.labels.status") },
  { key: "email", label: t("common.labels.email") },
]);

function fetchData() {
  userList({
    limit: limit.value,
    search: search.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        tableData.value = data.list;

        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changePage(value: number) {
  page.value = value;
}

function searchItem(value: string) {
  search.value = value;

  fetchData();
}

function addItem() {
  showModalAdd.value = true;
  isEdit.value = false;
}

function addItemConfirm() {
  if (!payload.value || !payloadValid.value) return;

  store.commit("SET_LOADING", true);

  userAdd(payload.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        submitCancel();
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function editItem(value: UserType) {
  selected.value = value;
  showModalAdd.value = true;
  isEdit.value = true;
}

function editItemConfirm() {
  if (!payload.value || !payloadValid.value) return;

  store.commit("SET_LOADING", true);

  userUpdate(selected.value.user_id, payload.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        submitCancel();
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function removeItem(data: UserType) {
  if (!data.deletable) {
    toast({ message: t("common.texts.not_deletable"), type: "error" });
    return;
  }

  selected.value = data;
  showModalDel.value = true;
}

function removeItemCancel() {
  selected.value = null;
  showModalDel.value = false;
}

function removeItemConfirm() {
  if (!selected.value) return;

  store.commit("SET_LOADING", true);

  userDel(selected.value.user_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        removeItemCancel();
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function submitCancel() {
  selected.value = null;
  payload.value = null;
  payloadValid.value = false;
  showModalAdd.value = false;
}

function submitPayload() {
  if (isEdit.value) {
    editItemConfirm();
  } else {
    addItemConfirm();
  }
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_unref(breadcrumbSimple), {
          items: breadcrumbList.value,
          "show-home": true,
          "url-home": "/home",
          active: "users"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(svgIcon), {
            icon: "group",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.users")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(baseTable), {
            header: tableHeader.value,
            data: tableData.value,
            limit: limit.value,
            page: page.value,
            pages: pages.value,
            total: total.value,
            searched: searched.value,
            options: true,
            del: true,
            edit: true,
            "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
            onSearching: _cache[1] || (_cache[1] = ($event: any) => (searchItem($event))),
            "onBtn:add": _cache[2] || (_cache[2] = ($event: any) => (addItem())),
            "onBtn:edit": _cache[3] || (_cache[3] = ($event: any) => (editItem($event))),
            "onBtn:del": _cache[4] || (_cache[4] = ($event: any) => (removeItem($event)))
          }, {
            status: _withCtx(({ data }) => [
              (data.active)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.active")), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.inactive")), 1)
                  ], 64))
            ]),
            name: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.first_name) + " " + _toDisplayString(data.last_name ?? ""), 1)
            ]),
            type: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(userTypes.value[data.type]), 1)
            ]),
            _: 1
          }, 8, ["header", "data", "limit", "page", "pages", "total", "searched"])
        ])
      ])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: _unref(t)('user.modals.titles.user_add').toUpperCase(),
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[7] || (_cache[7] = ($event: any) => (submitCancel())),
      onConfirm: _cache[8] || (_cache[8] = ($event: any) => (submitPayload()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(FormUser), {
          data: selected.value,
          "is-edit": isEdit.value,
          onUpdateData: _cache[5] || (_cache[5] = ($event: any) => (payload.value = $event)),
          onValidate: _cache[6] || (_cache[6] = ($event: any) => (payloadValid.value = $event))
        }, null, 8, ["data", "is-edit"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('user.modals.titles.user_remove').toUpperCase(),
      message: _unref(t)('user.modals.messages.user_remove', { name: selected.value?.name }),
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (removeItemCancel())),
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (removeItemConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})